<template>
  <div>
    <jet-dialog-modal max-width="3xl" :show="true">
      <template #title>
        <div class="flex justify-between items-center">
          <h2 class="sm:pt-4 pt-2 lg:text-2xl sm:text-lg text-sm">
            Update Guideline
          </h2>
          <jet-secondary-button @click="closeModel" class="cursor-pointer pt-4">Close</jet-secondary-button>
        </div>
      </template>

      <template #content>
        <TableIndexLayout>
          <div class="-my-2">
            <div class="py-2 align-middle inline-block w-full overflow-auto">
              <div class="border border-gray-50 overflow-x-auto max-height ">

                <div class="flex lg:flex-nowrap flex-wrap font-bold">
                  <div class="flex mt-6 ml-4 md:w-40 w-full">
                    <label class="">Meal Type*</label>
                  </div>
                  <div class="flex mt-4 ml-4 lg:w-56 md:w-40 w-full">
                    <div class="relative focus:outline-none lg:w-56 md:w-40 w-full mr-3 xl:mt-0 md:ml-2 ml-0">
                      <select disabled id="meal_type_id" name="meal_type_id" v-model="form.meal_type_id"
                        class="input-background shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-full select-menu-height"
                        @change="updateGuidelineValues">
                        <option value="">Select</option>
                        <option v-for="mealVal in mealtype_data" :value="mealVal.id">{{ mealVal.name }}</option>
                      </select>
                      <div
                        class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none new-dropdown">
                        <i class="fa fa-sort-desc" aria-hidden="true"></i>
                      </div>
                      <div v-if="form.errors.meal_type_id" class="validation_error_msg">{{
                        form.errors.meal_type_id }}</div>
                    </div>
                  </div>
                </div>

                <div class="flex lg:flex-nowrap flex-wrap font-bold">
                  <div class="flex mt-6 ml-4 md:w-40 w-full">
                    <label class="">Age Range*</label>
                  </div>
                  <div class="flex mt-4 ml-4 lg:w-56 md:w-40 w-full">
                    <div class="relative focus:outline-none lg:w-56 md:w-40 w-full mr-3 xl:mt-0 md:ml-2 ml-0">
                      <select disabled id="age_grade_id" name="age_grade_id" v-model="form.age_grade_id"
                        class="input-background shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-full select-menu-height"
                        @change="updateGuidelineValues">
                        <option value="">Select</option>
                        <option v-for="ageVal in agerange_data" :value="ageVal.id">{{ ageVal.name }}</option>
                      </select>
                      <div
                        class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none new-dropdown">
                        <i class="fa fa-sort-desc" aria-hidden="true"></i>
                      </div>
                      <div v-if="form.errors.age_grade_id" class="validation_error_msg">{{
                        form.errors.age_grade_id }}</div>
                    </div>
                  </div>
                </div>

                <div class="flex lg:flex-nowrap flex-wrap font-bold">
                  <div class="flex mt-6 ml-4 md:w-40 w-full">
                    <label class="">Days*</label>
                  </div>
                  <div class="flex mt-4 ml-4 lg:w-56 md:w-40 w-full">
                    <div class="relative focus:outline-none lg:w-56 md:w-40 w-full mr-3 xl:mt-0 md:ml-2 ml-0">
                      <select id="days_id" name="days_id" v-model="form.days_id"
                        class="input-background shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-full select-menu-height"
                        @change="updateGuidelineValues">
                        <option v-for="daysVal in days_data" :value="daysVal.id">{{ daysVal.name }}</option>
                      </select>
                      <div
                        class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none new-dropdown">
                        <i class="fa fa-sort-desc" aria-hidden="true"></i>
                      </div>
                      <div v-if="form.errors.days_id" class="validation_error_msg">{{ form.errors.days_id }}</div>
                    </div>
                  </div>
                </div>
                <div class="flex lg:flex-nowrap flex-wrap font-bold items-center w-full">
                  <div class="flex mt-6 ml-4 md:w-40 w-full">
                    <label>Guideline*</label>
                  </div>
                  <div class="flex mt-4 ml-4 lg:w-56 md:w-40 w-full">
                    <div class="relative focus:outline-none lg:w-56 md:w-40 w-full mr-3 xl:mt-0 md:ml-2 ml-0">
                      <select id="guideline_id" v-model="form.guideline_id" name="guideline_id"
                        class="input-background shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-full select-menu-height">
                        <option v-for="(guideline, index) in guidelines" :value="guideline.id">
                          {{ guideline.name }}</option>
                      </select>
                      <div
                        class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none new-dropdown">
                        <i class="fa fa-sort-desc" aria-hidden="true"></i>
                      </div>
                      <div v-if="form.errors.guideline_id" class="validation_error_msg">{{
                        form.errors.guideline_id }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </TableIndexLayout>
      </template>

      <template #footer>
        <div class="flex lg:flex-nowrap flex-wrap lg:justify-end md:justify-end justify-start"><!--v-if-->
          <button @click="closeModel"
            class="md:w-24 w-full button-color text-white font-bold py-3 rounded lg:mt-0 sm:mt-4 px-4 cancel-background-color leading-4 inline-block">CANCEL</button>
          <button v-if="this.form.guideline_id" type="submit" @click="updateGuideline"
            class="md:w-24 w-full button-color text-white font-bold py-3 rounded md:mt-0 mt-4 px-4 md:ml-2 ml-0 leading-4">UPDATE</button>
        </div>
      </template>
    </jet-dialog-modal>
  </div>
</template>

<script>
import vClickOutside from "click-outside-vue3";
import JetDialogModal from "@/Jetstream/DialogModal";
import $ from 'jquery';

export default {
  directives: {
    clickOutside: vClickOutside.directive,
  },

  props: ["menuCycle", "mealTypeImport", "daysImport", "graderanges"],

  components: {
    vClickOutside,
    JetDialogModal,
  },

  data() {

    return {
      days_data: this.daysImport,
      guidelines: [],
      agerange_data: this.graderanges,
      mealtype_data: this.mealTypeImport,
      form: this.$inertia.form({
        menu_cycle_id: this.menuCycle.id,
        meal_type_id: this.menuCycle.meal_type_id,
        days_id: this.menuCycle.days_id,
        guideline_id: this.menuCycle.guideline_id,
        age_grade_id: this.menuCycle.age_grade_id
      }),
    };
  },

  mounted() {
    this.loadGuidelineValues();
  },

  methods: {
    onClickOutside(event) {
      this.is_show = 0;
    },

    updateGuideline() {
      this.form.post(this.route('menu-cycle-guideline-edit-save', this.menuCycle.id), {
        onError: (error) => {
          console.log('test error', error);
          this.form.errors = error;
        },
        onSuccess: () => {
          this.$toast.success('Guildeline has been Updated Successfully!');
          this.menuCycle.days_id = this.form.days_id;
          this.menuCycle.guideline_id = this.form.guideline_id;
          this.loadCalendar();
          this.$emit('closeModal');
        },
      });
    },
    loadCalendar() {
      console.log("loadCalendar");
      this.$emit('loadCalendar');
    },

    importAllData() {
      axios.post('/get-week-cycle-list', { meal: this.mealType, age_range: this.grageRange, days: this.daysFilterVal, user: this.user_id })
        .then((response) => {
          this.menuCylces = response.data;
        })
        .catch(error => console.error(error));
    },

    loadGuidelineValues() {
      if (this.form.meal_type_id && this.form.age_grade_id && this.form.days_id) {
        axios.post('/site-offering-get-guidelines', {
          meal_type: this.form.meal_type_id,
          age_range: this.form.age_grade_id,
          days: this.form.days_id,
        }).then((response) => {
          this.guidelines = response.data;
        })
          .catch(error => console.error(error));
      }
    },

    updateGuidelineValues() {
      if (this.form.meal_type_id && this.form.age_grade_id && this.form.days_id) {
        this.form.guideline_id = null;
        axios.post('/site-offering-get-guidelines', {
          meal_type: this.form.meal_type_id,
          age_range: this.form.age_grade_id,
          days: this.form.days_id,
        }).then((response) => {
          this.guidelines = response.data;
        })
          .catch(error => console.error(error));
      }
    },
    closeModel() {
      console.log("closeModel");
      this.hideShowLoader('hide');
      this.$emit('closeModal');
    },

    hideShowLoader(types) {
      if (types == 'show') {
        document.getElementById('full_loader').style.display = 'flex';
      } else {
        document.getElementById('full_loader').style.display = 'none';
      }
    }
  },
};
</script>
<style>
.h-screen-95 {
  height: 95vh;
}

.h-screen-65 {
  height: 65vh;
}
</style>